export async function withdrawDeposits(args) {
    const { spaceDapp, depositIds, signer, smartAccount } = args;
    if (!spaceDapp?.baseRegistry) {
        throw new Error('BaseRegistry not found');
    }
    const callDataArray = depositIds.map((depositId) => spaceDapp.baseRegistry.rewardsDistributionV2.interface.encodeFunctionData('withdraw', [
        depositId,
    ]));
    const toAddressArray = Array(depositIds.length).fill(spaceDapp.config.addresses.baseRegistry);
    return smartAccount.sendUserOp({
        toAddress: toAddressArray,
        callData: callDataArray,
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
